<template>
    <div class="page bg-blue relative desktop-footer">
        <div class="bg-head-coin sm:block"></div>
        <div class="page-content sm:px-8 pb-5">
            <TopBar title="Home" :isShowOnlyLogo="true" :modalController="modalController"></TopBar>
            <MenuDesktop activeMenu="home"></MenuDesktop>
            <div class="sm:bg-white sm:px-5 sm:py-6 mt-4 rounded-25 flex flex-col">
                <div class="bg-white rounded-25 p-6 pb-3 mx-3 h-full flex-1">
                    <FormRegister
                        ref="form-register"
                        :form="form" :controller="modalController" />
                    <div class="pt-5">
                    <CheckBoxPdpd
                        v-model:check="form.checkTermandcondition"
                        @update:check="checkAcceptTerm()"
                        :controller="modalController"/>
                    </div>
                    <div class="text-center pt-6">
                        <Submitbtn @click="onSubmit()" :isBtnDisable="isBtnDisable">
                            {{ lbl.register.form.confirm }}
                        </Submitbtn>
                    </div>
                    <div class="pb-2 pt-6 block sm:hidden">
                        <img class="logo-powerby m-auto" src="../../../assets/logo/power-tip.png">
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//helper
// import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
import CacheHelper from '@/helper/CacheHelper.js';
import Account from "@/helper/AccountHelper.js";
import LineFunction from '@/helper/facade/LineFunction.js';
import FBFunction from '@/helper/facade/FBFunction.js';
//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import FormRegister from '@/module/Register/component/FormRegister.vue';
import Submitbtn from "@/module/Register/component/SubmitBtn.vue";
import CheckBoxPdpd from '@/module/Register/component/Input/CheckboxPdpdRegister.vue';
//service
import BzbsRegister from "../service/BzbsRegister.js";
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";
import BzbsAuth from "@/core/Account/service/BzbsAuth";
import { AuthLoginModelBuilder } from '@/core/Account/config/AuthConfigModel';
import { RegisterModel , ValidateForm } from '@/core/Account/model/RegisterModel';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'Register',
    mixins: [ModalMixin,LocaleMixin],
    components: {
        TopBar,
        MenuDesktop,
        BottomBar,
        FormRegister,
        CheckBoxPdpd,
        Submitbtn
    },
    data: function() {
        return {
            form: new RegisterModel(),
            isBtnDisable: true,
            registerChannel: null,
        };
    },
    created: function() {
        // this.initPdpa();
        this.initialFormRegister();
        let cache = new CacheHelper('local');
        this.registerChannel = cache.getCache('register_channel');
    },
    mounted: async function () {
        console.log(this.registerChannel)
        if(this.registerChannel == 'facebook'){ //facebook
            this.form.registerchannel = 'facebook';
            this.form.register_channel = 'facebook';
            this.form.idToken = await this.getFacebookAccessToken();
        }else{
            this.initLiff();
        }

    },
    methods: {
        initLiff: function() {
            var lineFunction = new LineFunction();
            this.liffId = lineFunction.getLiffId();

            lineFunction.init(this.liffId).then(() => {
                let lineIdToken = lineFunction.getIdToken();

                if (lineIdToken != null) {
                    this.form.idToken = lineIdToken;
                    this.form.registerchannel = 'line';
                    this.form.register_channel = 'line';
                } else {
                    this.setNotLineRegister();
                }

            }).catch((err) => {
                console.log(err);
                this.setNotLineRegister();
                // this.$router.replace('/error');
            });
        },
        setNotLineRegister: function() {
            this.form.idToken = null;
            this.form.registerchannel = 'buzzebees';
            this.form.registerchannel = 'buzzebees';
        },

        initialFormRegister: function () {
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            var cacheRegister = cacheHelper.getCache('registerData');
            if(cacheRegister){
                this.form.idcard =  cacheRegister.idCard;
                this.form.contact_number =  cacheRegister.mobile;
                this.form.otp =  cacheRegister.otp;
                this.form.refcode =  cacheRegister.refcode;
                this.form.passport = cacheRegister.passport;
                this.form.nationality = cacheRegister.nationality;
            }
            let cacheSession = new CacheHelper('session');
            let cacheFillForm = cacheSession.getCache('fill_form_register');
            console.log('cache fill', cacheFillForm);
            if (cacheFillForm != null) {
                this.form.firstName = cacheFillForm.FirstName;
                this.form.lastName = cacheFillForm.LastName;
                if (cacheFillForm.Gender == 'F') {
                    this.form.gender = 'female';
                } else if (cacheFillForm.Gender == 'M') {
                    this.form.gender = 'male';
                }
            }
        },
        checkAcceptTerm: function(){
            if(this.form.checkTermandcondition){
                this.isBtnDisable = false
            }else {
                this.isBtnDisable = true
            }
        },
        //#region flow submit register
        onSubmit: function(){
            let checkFormatPassword = new ValidateForm().checkFormatPassword(this.form);
            if(!this.isBtnDisable){
                const validateRegister = this.$refs['form-register'].validateRegisterForm();
                if(!validateRegister.pass){
                    this.modalController.alertModal.setMsg(validateRegister.msg).show();
                }else if(!checkFormatPassword){
                    this.modalController.alertModal
                        .setMsg(this.lbl.home.login.condition_password)
                        .show();
                } else{
                    this.submitFormToApi(this.form);
                }
            }
        },
        submitFormToApi:async function (data) {
            this.modalController.loadingModal.setMsg(this.lbl.register.loading_register).show();
            await this.initPdpa();
            var success = await this.callApiRegister(data);
            if (success) {
                let authParams = new AuthLoginModelBuilder()
                    .setUsername(this.form.contact_number)
                    .setPassword(this.form.password)
                    .create()
                    .getParams();

                setTimeout(async () => {
                    await this.apiLogin(authParams);
                    this.modalController.loadingModal.hide();
                    this.showPoint();
                }, 3000);
            }
        },
        callApiRegister: function (data) {
            let cache = new CacheHelper('local');
            let refcodeGetFriend = cache.getCache('refcode');
            data.refcodeGetFriend = refcodeGetFriend;
            let params = new RegisterModel().getParamsRegister(data);
            this.loadingModal.clearModal()
                    .setMsg(this.lbl.register.form.loading_register)
                    .show();
            console.log(params)
            return new Promise((resolve)=>{
                BzbsRegister.registerMember(params)
                    .subscribe({
                        next: (point) => {
                            this.point = point;
                            resolve(true);
                        },
                        error: (err) => {
                            console.log(err);
                            this.alertModal
                                .clearModal()
                                .setTitle(this.lbl.register.no_data)
                                .setMsg(err.message)
                                .show()
                            this.modalController.loadingModal.hide();
                            resolve(null);
                        }
                });
            });
        },
        showPoint: function () {
            var pointType = 'point';
            if (!this.point) {
                pointType = 'notpoint'
            }
            this.alertPointModal
                .clearModal()
                .setPoint(this.point)
                .setType(pointType)
                .show();


            this.alertPointModal.onClickOk(() => {
                this.$router.push('/home?newregister=true');
            });
        },
        callApiGetPolicy: function (data) {
            var params = new RegisterModel().getParamsRegister(data);
            return new Promise((resolve)=>{
                BzbsRegister.getPolicy(params)
                    .subscribe({
                        next: (res) => {
                            resolve(res);
                            this.showPoint();
                        },
                        error: (err) => {
                            console.log(err);
                            if (err.code == '404001') {
                                this.alertPointModal
                                    .clearModal()
                                    .setPoint(0)
                                    .setType("notpoint")
                                    .show();
                            }
                            resolve(null);
                        }
                });
            });
        },
        initPdpa: async function () {
            await this.apiGetUserConsent();
        },
        apiGetUserConsent: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetUserConsent()
                    .subscribe({
                        next: (res) => {
                            this.form.pdpaVersion = res.data.purposes[0].version;
                            resolve(this.consent);
                        },
                        error: (err) => {
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
        apiLogin: function(authParams) {
            return new Promise((resolve) => {
                BzbsAuth.apiLogin(authParams).subscribe({
                    next: (data) => {
                        Account.setLogin(data);
                        resolve();
                    },
                    error: (err) => {
                        console.log(err);
                        this.errorMsg = err.message;
                        this.errorApi(err);
                        resolve();
                    },
                });
            });
        },
        apiLoginLine: function(idToken) {
            return new Promise((resolve) => {
                BzbsAuth.apiLoginLine(idToken).subscribe({
                    next: (data) => {
                        Account.setLogin(data);
                        resolve();
                    },
                    error: (err) => {
                        console.log(err);
                        this.errorMsg = err.message;
                        this.errorApi(err);
                        resolve();
                    },
                });
            });
        },
        getFacebookAccessToken: function () {
            return new Promise((resolve) => {
                let fb = new FBFunction();
                fb.getLoginStatus().then((data) => {
                    let accessToken = data?.accessToken;
                    resolve(accessToken);
                }).catch(() => {
                    resolve(null);
                });
            });

        },
        //#endregion flow submit register
    },
}
</script>
<style lang="scss" scoped>
.logo-powerby {
        width: 166px;
    }
</style>
